import { action as apiAction } from 'api/Api'

type Payload = {
  parentId: number
  name: string
  statusId: number
  groupId?: number
  position?: number
  template: any
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { name, parentId, statusId, groupId, position, template } = payload

  const args: any = {
    cardId: parentId,
    addCard: {
      name: name.trim(),
      statusId,
      template,
    },
  }

  if (statusId && getState()['view-board'].cards[parentId]?.statusId === statusId) {
    args.addCard.statusPosition = { below: parentId }
  }

  if (groupId) {
    args.groupTarget = {
      groupId,
      position,
    }
  }

  await apiAction('AddNewChildCard', args)
}
